import React from 'react';
import { useSelector } from 'react-redux';
import { selectDealsList } from '../dealsList/dealsListSlice';
import translate from '../../utilities/translator';
import { searchInOneDestination } from '../../utilities/helpers';
import { selectFilterData } from '../mainFilter/selectors';

export default function DestinationList() {
  const mainFilter = useSelector(selectFilterData);
  const { pending, error, pagination, nextDeals } = useSelector(selectDealsList);

  const { where } = mainFilter.searchEngine;
  const activeDestinations = where?.destinations?.filter(
    ({ active }) => active
  );
  const activeDestinationsCount = activeDestinations?.length;
  const isMultipleDestination =
    activeDestinationsCount > 1 || activeDestinationsCount === 0;

  if (
    !isMultipleDestination ||
    error ||
    pending ||
    pagination.current_offers_page !== pagination.total_offers_pages ||
    nextDeals.length > 0
  )
    return '';

  return (
    <div className="one-destination__list c-row">
      {activeDestinations.map(({ id, value, name }) => (
        <div
          key={id}
          className="one-destination__item col-lg-12"
          onClick={searchInOneDestination(id)}
        >
          <div className="one-destination__item__icon">
            <i className="ri-map-pin-2-fill"></i>
          </div>
          <div className="one-destination__item__content">
            <p>
              {translate('holidayFinder.destination_list.discover_more_in')} {' '}
              <span>{name}</span>
            </p>
            <p>
              {translate(
                'holidayFinder.destination_list.hundreds_offers_available'
              )}
            </p>
          </div>
          <i className="one-destination__item__arrow ri-arrow-right-s-line"></i>
        </div>
      ))}
    </div>
  );
}
